import { useEffect, useState } from "react";

const PREFIX = "decoder-";

export default function useLocalStorage(key, initialValue) {
  const prefixedKey = PREFIX + key;

  const [value, setValue] = useState(() => {
    const jsonValue = localStorage.getItem(prefixedKey);
    if (jsonValue !== null || jsonValue !== "undefined")
      return JSON.parse(jsonValue);

    if (typeof initialValue === "function") {
      return initialValue();
    } else {
      return initialValue;
    }
  });

  const watchStorage = () => {
    let storageValue = localStorage.getItem(prefixedKey);

    if (storageValue && storageValue !== value)
      setValue(JSON.parse(storageValue));
  };

  useEffect(() => {
    localStorage.setItem(prefixedKey, JSON.stringify(value));
  }, [prefixedKey, value]);

  useEffect(() => {
    window.addEventListener("storage", watchStorage);

    return () => window.removeEventListener("storage", watchStorage);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [value, setValue];
}
